import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

// The box owns the border, height and background so the projected control
// never draws one of its own.
@Component({
    selector: 'app-form-field',
    templateUrl: 'form-field.component.html',
    styleUrls: ['form-field.component.scss'],
    standalone: false
})
export class FormFieldComponent {
  @Input() label: string;

  // Hint shown next to the label, e.g. "(1 per line)".
  @Input() labelTip: string;

  @Input() control: AbstractControl;
  @Input() markAsDirty: boolean;

  // One label over a set of sibling fields (a repeating control) rather than
  // over one control. The children draw their own boxes, so this draws none.
  @Input() grouped = false;

  // Passed straight through to app-form-control. `parent` flags errors that
  // live on the control's parent group rather than the control itself.
  @Input() errors: { name: string; text: string; parent?: boolean }[];
}
